<template>
  <div class="home">
    <van-nav-bar title="首页" left-text="注销" left-arrow @click-left="onClickLeft()"></van-nav-bar>
    <ul class="home-content">
      <li class="pda-div-father" v-for="(i, index) in url_list" :key="index">
        <div class="pad-div" @click="gourl(i.go_url)">
          <div><van-icon :name="i.icon_name" size="40px" /></div>
          <div style="margin-top: 0.3rem">{{ i.title }}</div>
        </div>
      </li>
    </ul>
    <div></div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "home",
  data() {
    return {
      url_list: [
        // { icon_name: "ecard-pay", title: "入库单", go_url: "" },
        //{ icon_name: "ecard-pay", title: "RCS入库", go_url: "RscWarehousing" },
        //{ icon_name: "peer-pay", title: "RCS出库", go_url: "RscOutInfo" },
        //{ icon_name: "peer-pay", title: "明细码出库单", go_url: "allout" },
        // { icon_name: "exchange", title: "调拨单", go_url: "" },
        // { icon_name: "records", title: "流转单", go_url: "" },
        // { icon_name: "plus", title: "现存量", go_url: "" },
        // { icon_name: "edit", title: "商品标签打印", go_url: "" },
        //{ icon_name: "logistics", title: "装箱单", go_url: "fillingGoods" },
        //{ icon_name: "newspaper-o", title: "装箱单列表", go_url: "FGlist" },
        { icon_name: "plus", title: "计件", go_url: "cards" },

        //{ icon_name: "peer-pay", title: "领料出库单", go_url: "orderInfo" },
        //{ icon_name: "peer-pay", title: "称重出库单", go_url: "weightOutInfo" },
        //{ icon_name: "cart-o", title: "领料出库列表", go_url: "outlist" },
        //{icon_name: "newspaper-o",title: "出库单列表",go_url: "cleanOutlist",},


        // { icon_name: "exchange", title: "裁切", go_url: "Reelcrop" },
        // { icon_name: "peer-pay", title: "订单出库", go_url: "cleanOutInfo" },
        // { icon_name: "peer-pay", title: "直接出库", go_url: "directOutbound" },
        // { icon_name: "peer-pay", title: "入箱扫码", go_url: "inboundScanning" },
        // { icon_name: "newspaper-o", title: "待出箱列表", go_url: "outBoxList" },
        // { icon_name: "exchange", title: "卷号出入仓", go_url: "WarehouseStocking" },
        // { icon_name: "exchange", title: "明细码/货号出仓", go_url: "WarehouseOutbound" },
        // { icon_name: "upgrade", title: "布匹调整", go_url: "FabricAdjustment" },
        // { icon_name: "cluster-o", title: "布匹盘点", go_url: "FabricInventory" },
        // { icon_name: "peer-pay", title: "订单入库", go_url: "OrderIn" },
        // { icon_name: "cart-o", title: "出库装箱", go_url: "OutPicking" },
        { icon_name: "shrink", title: "成品入库", go_url: "Finished-in" },
        { icon_name: "expand-o", title: "成品出库", go_url: "Finished-out" },
        // { icon_name: "ecard-pay", title: "半成品入库", go_url: "Finished-in-B" },
        // { icon_name: "peer-pay", title: "半成品出库", go_url: "Finished-out-B" },
        // { icon_name: "records", title: "新建布匹入库", go_url: "NewFabricStock-in" },
        // { icon_name: "failure", title: "新建退货", go_url: "ReturnWarehouse" },
        // { icon_name: "orders-o", title: "待拣货列表", go_url: "orderDetailsList" },
        // { icon_name: "newspaper-o", title: "待发货表", go_url: "FabricOutList" },
        // { icon_name: "new-o", title: "货位上架", go_url: "GoodsPut" },
        // { icon_name: "exchange", title: "货位调拨", go_url: "allocation" },
        { icon_name: "phone-o", title: "蓝牙连接", go_url: "bluetoothLink" },
        // { icon_name: "info-o", title: "其他", go_url: "otherUrl" },
        // { icon_name: "info", title: "通信", go_url: "communicate" }
      ],
      isWeb: false,
    };
  },
  // created() {
  //   // 判断是否在网页中打开
  //   if (window.location.protocol === 'http:' || window.location.protocol === 'https:'|| window.location.protocol === 'localhost:') {
  //     this.isWeb = true; // 在网页中打开，将 isWeb 设置为 true
  //     this.url_list=this.url_list.filter(item => item.go_url !== "NewFabricStock-in");
  //   } else {
  //     this.isWeb = false; // 在 App 中打开，将 isWeb 设置为 false
  //   }
  // },
  mounted() {
    this.getNumber("");
  },
  methods: {
    ...mapMutations(["getNumber"]),
    onClickLeft() {
      localStorage.removeItem("checked_auto");
      localStorage.removeItem("userinfo");
      this.$router.push("/");
    },
    gourl(url) {
      new Promise((res, rej) => {
        if (url === "fillingGoods") {
          this.$router.push("/" + url + "?id=&FGid=&number=");
        } else if (url === "otherUrl") {
          let base = window.location.origin;
          let requestUrl = ""
          if (base.includes('localhost')) {
            requestUrl = 'http://cspda.lcyjfz.com'
          } else {
            requestUrl = base
          }
          var subDomain = requestUrl.split('.')[1];
          let url = 'http://' + localStorage.getItem('enterpriseCode') + '.' + subDomain + '.com/notice/2';
          console.log(url);//
          window.location.href = url;
        } else {
          this.$router.push("/" + url);
        }
        res();
      }).then(() => {
        setTimeout(() => {
          //window.location.reload();
        }, 500);
      });
    },
  },
};
</script>
<style lang="less">
.home {
  width: 100%;
}

* {
  font-size: 0.32rem;
}

.home-content {
  display: flex;
  flex-wrap: wrap;
}

.pda-div-father {
  width: 33%;
  padding: 1rem 0;
  border-top: 0.5px solid #333333;
}

li {
  list-style-type: none;
}
</style>
